import {Environment} from '../app/common/entity/enviroment';

export const environment: Environment = {
  fileManagerUrl: '',
  authenticationUrl: '',
  baseUrl: ''
};
